<template>
  <v-chip
    v-if="max"
    :color="getStatusColor(status.name)"
    text-color="white"
    style="width: 100%; max-width: 250px"
    label
  >
    {{ status.text }}
  </v-chip>
  <v-chip
    v-else
    :color="getStatusColor(status.name)"
    text-color="white"
    style="max-width: 250px"
    label
  >
    {{ status.text }}
  </v-chip>
</template>

<script>
export default {
  name: 'MessageStatus',
  props: {
    status: {
      type: Object,
      required: true,
    },
    max: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getStatusColor(status) {
      let color = '#2281C9'

      switch (status) {
        case 'NEW':
          color = '#ffc107'
          break

        case 'READ':
          color = '#2281C9'
          break

        default:
          color = '#2281C9'
      }

      return color
    },
  },
}
</script>
